import './styles/App.css';
import AppRouter from './components/AppRouter';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchStateMain, initializeAuth } from './store/storeSlice';
import { useDispatch } from 'react-redux';
import Notifier from './components/shared/Notifier';
import { Box, CircularProgress, Typography } from '@mui/material';

// Функция для установки правильной высоты viewport на мобильных устройствах
export const setViewportHeight = () => {
    // Получаем реальную высоту viewport
    const vh = window.innerHeight * 0.01;
    
    // Устанавливаем CSS переменную для использования в стилях
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    
    // Обновляем также классическую vh переменную
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    // Для мобильных устройств дополнительно проверяем safe area и navbar
    const isMobile = window.innerWidth <= 768;
    // const navbarHeight = isMobile ? 48 : 56;
    // const navbarHeight = document.getElementById('NavBar')?.offsetHeight || (isMobile ? 36 : 40)
    // console.log(document.getElementById('NavBar')?.offsetHeight)
    // // Устанавливаем высоту navbar
    // document.documentElement.style.setProperty('--navbar-height', `${navbarHeight}px`);
    
    if (isMobile) {
      // Получаем значение safe-area-inset-bottom
      // const computedStyle = getComputedStyle(document.documentElement);
      // const safeAreaBottom = computedStyle.getPropertyValue('--safe-area-bottom') || '0px';
      
      // console.log(`📱 Мобильное устройство: viewport ${window.innerHeight}px, navbar: ${navbarHeight}px, safe-area-bottom: ${safeAreaBottom}`);
      
      // Для iOS Safari и других мобильных браузеров
      if (/iPhone|iPad|iPod|iOS|Android/i.test(navigator.userAgent)) {
        // Принудительно устанавливаем высоту без учета адресной строки
        const realHeight = window.screen.height;
        const currentHeight = window.innerHeight;
        
        if (Math.abs(realHeight - currentHeight) > 100) {
          // Если разница большая, значит адресная строка видна
          document.documentElement.style.setProperty('--viewport-height', `${currentHeight}px`);
        }
      }
    }
  };
  
  // Функция для обработки изменения ориентации устройства
  const handleOrientationChange = () => {
    // Небольшая задержка для корректного расчета размеров после поворота
    setTimeout(() => {
      setViewportHeight();
    }, 100);
  };

const App = () => {
    const dispatch = useDispatch();
    const isAuth = useSelector(state => state.store.user.isAuth);
    const isLoading = useSelector(state => state.store.isLoading);

    // Устанавливаем правильную высоту viewport при загрузке
    useEffect(() => {
        setViewportHeight();
        
        // Слушаем изменения размера окна
        window.addEventListener('resize', setViewportHeight);
        
        // Слушаем изменения ориентации (для мобильных устройств)
        window.addEventListener('orientationchange', handleOrientationChange);
        
        // Дополнительная обработка для iOS
        window.addEventListener('scroll', setViewportHeight);
        
        // Используем Visual Viewport API для более точного отслеживания на мобильных
        if (window.visualViewport) {
          const handleVisualViewportChange = () => {
            const isMobile = window.innerWidth <= 768;
            // const navbarHeight = isMobile ? 48 : 56;
            // const navbarHeight = document.getElementById('NavBar')?.offsetHeight || (isMobile ? 40 : 40)
            // console.log(`📱 Visual Viewport изменился: ${window.visualViewport.height}px, navbar: ${navbarHeight}px`);
            document.documentElement.style.setProperty('--viewport-height', `${window.visualViewport.height}px`);
            // document.documentElement.style.setProperty('--navbar-height', `${navbarHeight}px`);
          };
          
          window.visualViewport.addEventListener('resize', handleVisualViewportChange);
          window.visualViewport.addEventListener('scroll', handleVisualViewportChange);
          
          // Очистка для Visual Viewport API
          return () => {
            window.removeEventListener('resize', setViewportHeight);
            window.removeEventListener('orientationchange', handleOrientationChange);
            window.removeEventListener('scroll', setViewportHeight);
            
            if (window.visualViewport) {
              window.visualViewport.removeEventListener('resize', handleVisualViewportChange);
              window.visualViewport.removeEventListener('scroll', handleVisualViewportChange);
            }
          };
        }
        
        return () => {
          window.removeEventListener('resize', setViewportHeight);
          window.removeEventListener('orientationchange', handleOrientationChange);
          window.removeEventListener('scroll', setViewportHeight);
        };
      }, []);

    // Инициализация авторизации при загрузке приложения
    useEffect(() => {
        dispatch(initializeAuth());
    }, [dispatch]);

    useEffect(() => {
        console.log('Auth status changed:', isAuth)
        if (isAuth) {
            // Получаем начальное состояние через HTTP
            dispatch(fetchStateMain());
            
            // WebSocket подключение теперь управляется через хук useWebSocket
            // webSocketService.connect(); // УБРАНО - дублирование
            
            // Убираем HTTP polling, так как теперь используем WebSocket
            // const intervalId = setInterval(() => {
            //     dispatch(fetchStateMain());
            // }, 30000);
            // return () => clearInterval(intervalId);
        }
        // Отключение WebSocket теперь управляется через хук useWebSocket
        // webSocketService.disconnect(); // УБРАНО - дублирование
    }, [isAuth, dispatch]);


   

    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'var(--background-default)',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 9999,
                }}
            >
                <CircularProgress
                    size={48}
                    sx={{
                        color: 'var(--primary-color)',
                    }}
                />
                <Typography
                    sx={{
                        mt: 3,
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'var(--text-secondary)',
                    }}
                >
                    Загрузка...
                </Typography>
            </Box>
        );
    }


  

    return (
        <div className="App">
            <Notifier />
            <AppRouter />
        </div>
    );

}

export default App;
